import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/alipay.jpg';
const _withScopeId = n => (_pushScopeId("data-v-625266cc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "menu"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "box"
};
const _hoisted_4 = {
  class: "card"
};
const _hoisted_5 = {
  class: "btn"
};
const _hoisted_6 = {
  class: "card card1"
};
const _hoisted_7 = {
  class: "cardBox"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "选择金额：", -1));
const _hoisted_9 = {
  class: "monney"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card2"
}, [/*#__PURE__*/_createElementVNode("p", null, "充值方式："), /*#__PURE__*/_createElementVNode("div", {
  class: "zhifu"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})])], -1));
import { showFailToast } from "vant";
import { reactive, onMounted } from 'vue';
import Menu from "@/components/menu.vue";
import api from "@/api";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const data = reactive({
      checked: null,
      userId: '',
      account: '',
      pwd: '',
      money: 0,
      amounts: ['0.1', '100', '150', '200', '500']
    });
    onMounted(async () => {
      var _JSON$parse, _JSON$parse2, _JSON$parse3;
      const User = window.localStorage.getItem('user');
      data.userId = (_JSON$parse = JSON.parse(User)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.id;
      data.account = (_JSON$parse2 = JSON.parse(User)) === null || _JSON$parse2 === void 0 ? void 0 : _JSON$parse2.account;
      data.pwd = (_JSON$parse3 = JSON.parse(User)) === null || _JSON$parse3 === void 0 ? void 0 : _JSON$parse3.pwd;
      if (User) {
        await api.logins(data.account, data.pwd).then(res => {
          if (res.data.code == 0) {
            data.money = res.data.data.money;
          }
        });
      }
    });
    const selectMonney = async item => {
      console.log(item);
      data.checked = item;
    };
    const clikeMenu = async () => {};
    const toOrder = async () => {
      if (!data.checked) {
        showFailToast('请选择充值金额');
        return;
      }
      await api.order(data.userId, '成都百分百文化传播有限公司音乐产品', data.checked, 'http://cdbfb.net/#/recharge').then(res => {
        console.log(res.data);
        if (res.data.code == 0) {
          window.localStorage.setItem('orderId', res.data.data.orderid);
          window.location.href = res.data.data.data;
        } else {
          showFailToast(res.data.msg);
        }
      });
    };
    const Refresh = async () => {
      await api.logins(data.account, data.pwd).then(res => {
        if (res.data.code == 0) {
          data.money = res.data.data.money;
          alert('刷新成功');
        } else {
          showFailToast(res.data.msg);
        }
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Menu, {
        "active-name": ""
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("button", {
        onClick: Refresh,
        class: "order"
      }, "刷新"), _createElementVNode("p", null, "当前余额：" + _toDisplayString(data.money / 100) + "元", 1)])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.amounts, item => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["total", {
            'highlight': item == data.checked
          }]),
          key: item,
          onClick: $event => selectMonney(item)
        }, _toDisplayString(item) + "元", 11, _hoisted_10);
      }), 128))])])]), _createElementVNode("div", {
        class: "card",
        style: {
          "padding-bottom": "30px"
        }
      }, [_hoisted_11, _createElementVNode("div", {
        class: "btn"
      }, [_createElementVNode("button", {
        onClick: toOrder,
        class: "order",
        style: {
          "background": "#1989FA"
        }
      }, "充值")])])])])]);
    };
  }
});